import collapse_controller from "./collapse_controller";
import Popper from "popper.js";
import { useClickOutside } from "stimulus-use";
import EventBus from "js-event-bus";
import { white } from "ansi-colors";

const eventBus = EventBus();

export default class extends collapse_controller {
  static targets = ["toggle", "collapse", "heading", "body", "arrow"];
  popper;
  openKeys = ["Enter", " "];
  closeKeys = ["Escape"];

  /**
   * The controller has loaded.
   */
  connect() {
    super.connect();
    useClickOutside(this);
    this.popper = new Popper(this.toggleTarget, this.collapseTarget, {
      placement: this.placement,
      removeOnDestroy: true,
      modifiers: this.modifiers,
    });
    eventBus.on("popover:close", () => {
      if (this.opened) {
        this.close();
      }
    });
  }

  get placement() {
    return this.data.has("placement") ? this.data.get("placement") : "top-end";
  }

  get offset() {
    return this.data.has("offset") ? this.data.get("offset") : "0,15";
  }
  get modifiers() {
    let modifiers = {
      flip: {
        enabled: false,
      },
    };
    if (this.offset) {
      modifiers.offset = {
        offset: this.offset,
      };
    }
    if (this.hasArrowTarget) {
      modifiers.arrow = {
        element: this.arrowTarget,
        enabled: true,
      };
    }
    return modifiers;
  }

  handleClick() {
    if (this.closed) {
      eventBus.emit("popover:close");
    }
    this.toggle();
  }

  focus() {
    this.bodyTarget.focus();
  }

  /**
   * The controller has disconnected.
   */
  disconnect() {
    this.popper.destroy();
  }
}
